<mulo-centered-block-layout class="research-units-header">
    <a [routerLink]="['/research-units']" class="has-icon back-button" mat-button queryParamsHandling="preserve">
        <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-left"></mat-icon>
        {{ 'research.general.back' | translate }}
    </a>

    <div class="units-header-titles">
        <div class="breadcrumbs">
            <a [routerLink]="['/research-units']" class="crumb" queryParamsHandling="preserve">
                <mat-icon muloSvgViewbox svgIcon="graph-outline"></mat-icon>
                {{ 'research.search.academic.units' | translate }}
            </a>
            <span class="separator"></span>
            @for (crumbCode of breadcrumbsArray; track crumbCode) {
                <a
                    [queryParams]="unitLinkQueryParams(crumbCode)"
                    [routerLink]="unitSearchLink(crumbCode)"
                    class="crumb"
                >
                    {{ crumbCode | translate }} </a
                ><span class="separator"></span>
            }
        </div>
        <div class="title">
            <h1 id="head1">{{ unit?.name | translateObject }}</h1>
            @if (firstLevelSubUnits?.length > 0) {
                <button
                    [attr.aria-label]="'research.search.academic.units' | translate"
                    [matMenuTriggerFor]="subunitsMenu"
                    aria-describedby="head1"
                    mat-icon-button
                >
                    <mat-icon muloSvgViewbox style="width: 28px; height: 28px" svgIcon="menu-down"></mat-icon>
                </button>
            }
            <mat-menu #subunitsMenu="matMenu" [overlapTrigger]="true" class="hasnt-max-width">
                @for (subUnitCode of firstLevelSubUnits; track subUnitCode) {
                    <a
                        [queryParams]="unitLinkQueryParams(subUnitCode)"
                        [routerLink]="unitSearchLink(subUnitCode)"
                        mat-menu-item
                        queryParamsHandling="merge"
                    >
                        <span class="italics" style="font-weight: normal">
                            {{ subUnitCode | translate }}
                        </span>
                    </a>
                }
            </mat-menu>
        </div>
        @if (logos?.length > 0) {
            <div class="logo-wrap">
                <img
                    [alt]="'research.alt.logo' | translate: { value: unit?.name | translateObject }"
                    [src]="logos[0]?.viewUrl"
                />
            </div>
        }
        <mulo-centered-block-layout class="description-section">
            @if (descriptions?.length > 0) {
                <mulo-expandable
                    [collapseLabel]="'research.general.showLess' | translate"
                    [expandLabel]="'research.general.showMore' | translate"
                    [ratio]="9"
                    class="margin-bottom-md rich-text-reset"
                >
                    <div [innerHTML]="descriptions[0]?.value | translateObject"></div>
                </mulo-expandable>
            }
            @if (links?.length > 0) {
                <div class="links">
                    @for (link of links; track link.url) {
                        <a [href]="link.url">{{ link.displayName || link.url }}</a>
                        @if (!$last) {
                            <mulo-separator></mulo-separator>
                        }
                    }
                </div>
            }
        </mulo-centered-block-layout>
    </div>
</mulo-centered-block-layout>
